import { useEffect } from 'react'

export const useAsync = (effect: (isCancelled: () => boolean) => Promise<void | (() => void)>) =>
	useEffect(() => {
		let isCancelled = false
		let cleanup: undefined | (() => void)

		effect(() => isCancelled).then((result) => {
			if (result) {
				cleanup = result
			}
		})

		return () => {
			isCancelled = true
			cleanup?.()
		}
	}, [effect])
